import { getActions, getReducers, getTypes } from '../initializers';

// per-channel royale points leaderboard (public, no auth needed)
const identifier = 'POINTS_LEADERBOARD';

export const getLeaderboardState = (state) => state.points?.leaderboard;

export const types = getTypes(identifier);
export const actions = getActions(
  identifier,
  (params) =>
    `rngroyale/leaderboard/${encodeURIComponent(params.streamerId)}?window=${
      params.window || 'all'
    }`
);
const reducer = getReducers(identifier);

export default reducer;
